export interface Faq {
  id: string
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    id: 'solo-florida',
    question: '¿Este servicio es solamente para negocios en Florida?',
    answer:
      'La propuesta que ves en esta página está enfocada en la creación de negocios en Florida, por eso incluye el registro en Sunbiz y el fee estatal correspondiente. Si tu proyecto está en otro estado, cuéntanoslo en el formulario y revisamos juntas si podemos acompañarte.',
  },
  {
    id: 'ssn-ein',
    question: '¿Necesito tener SSN para obtener un EIN?',
    answer:
      'No siempre. Existen procesos distintos según tu situación personal y documentación, y cada caso se evalúa de forma individual. No ofrecemos asesoría legal ni fiscal: revisamos tu información y te explicamos con claridad qué camino aplica para ti antes de comenzar.',
  },
  {
    id: 'fee-estatal',
    question: '¿El fee estatal está incluido?',
    answer:
      'Sí. En el paquete Lanza tu Empresa, el fee estatal de Florida está incluido dentro del precio inicial de $597 que aparece en esta página.',
  },
  {
    id: 'tiempos',
    question: '¿Cuánto tarda el proceso?',
    answer:
      'Depende de los tiempos de procesamiento de las entidades gubernamentales y de los servicios que elijas. No podemos garantizar fechas exactas, pero sí te mantenemos informada en cada etapa y avanzamos con lo que sí está en nuestras manos mientras tanto.',
  },
  {
    id: 'todos-los-servicios',
    question: '¿Tengo que contratar todos los servicios?',
    answer:
      'No. Puedes comenzar con el servicio que necesitas hoy y sumar los demás a medida que tu negocio se desarrolla.',
  },
  {
    id: 'solo-creacion',
    question: '¿Puedo comenzar solamente con la creación de mi empresa?',
    answer:
      'Sí. Nuestros servicios son modulares: puedes iniciar únicamente con la creación de tu empresa y más adelante agregar identidad, web o presencia digital cuando sea el momento adecuado.',
  },
  {
    id: 'despues-de-enviar',
    question: '¿Qué sucede después de enviar mi información?',
    answer:
      'Revisamos lo que nos compartes para entender tu proyecto y su etapa actual, y así identificar cuál es el próximo paso más conveniente para ti. Después te contactamos para conversarlo.',
  },
]
